import React, { useEffect, useState } from 'react'
import { GetIcon } from '../../../../../icons'
import { Container, NotificationIcon, NotificationsContainer, NotiListItem, NotificationNumber } from './styles'
import { generateThumbnail } from '../../../../functions/string';
import { Profile } from '../header/styels';
import { deleteData, getData, postData } from '../../../../../backend/api';
import { useNavigate } from 'react-router-dom';
import { getTimeAgo } from '../../../../functions/timeAgoFormat';
import { useDispatch } from 'react-redux';

const Notification = ({setLoaderBox, setMessage, user, t}) => {
    const dispatch = useDispatch();
        const navigate = useNavigate();
    const [showNotifications, setShowNotifications] = useState(false);

    const [notifications, setNotifications] = useState({})

    const fetchNotifications = async () => {
        setLoaderBox(true);
      await getData({user: user._id}, "notification", dispatch, navigate)
        .then((response) => {
          if (response.status === 200) {
              setNotifications(response.data);
          } else if (response.status === 404) {
            setMessage({ type: 1, content: t(response.data), proceed: "Okay", code: 404 });
          } else {
            setMessage({ type: 1, content: t(response.data), proceed: "Okay", code: 500 });
          }
          setLoaderBox(false);
        })
        .catch((error) => {
          setMessage({ type: 1, content: error.message + "Something went wrong!", proceed: "Okay", code: 500 });
          setLoaderBox(false);
        });
    }

    useEffect(() =>{
        fetchNotifications();
    },[])

    const handleNotificationRead = async () => {
        if(notifications?.data?.length > 0 && notifications?.data?.filter((val) => !val.isRead).length > 0){
            const data = notifications?.data?.filter((val) => !val.isRead).map((val) => val._id);
            await postData({ids: data}, "notification/read", dispatch, navigate)
            .then((response) => {
                if (response.status === 200) {
                    setNotifications({
                        ...notifications,
                        data: notifications?.data?.map((val) => ({ ...val, isRead: true }))
                    });
                } else if (response.status === 404) {
                    setMessage({ type: 1, content: t(response.data), proceed: "Okay", code: 404 }); 
                } else {
                    setMessage({ type: 1, content: t(response.data), proceed: "Okay", code: 500 });
                }
                // setLoaderBox(false);
            })
            .catch((error) => {
                setMessage({ type: 1, content: error.message + "Something went wrong!", proceed: "Okay", code: 500 });
                // setLoaderBox(false);
            });
        }
    }
    const hanldeDeleteNotification = async (e,notification) => {
      setLoaderBox(true);
      await deleteData({}, "notification", notification._id, dispatch, navigate)
      .then((response) => {
          if (response.status === 200) {
              setNotifications({
                  ...notifications,
                  data: notifications?.data?.filter((val) => val._id !== notification._id)
              });
          } else if (response.status === 404) {
              setMessage({ type: 1, content: t(response.data), proceed: "Okay", code: 404 });   
          } else {
              setMessage({ type: 1, content: t(response.data), proceed: "Okay", code: 500 });
          }
          setLoaderBox(false);
      })
      .catch((error) => {
          setMessage({ type: 1, content: error.message + "Something went wrong!", proceed: "Okay", code: 500 });
          setLoaderBox(false);
      });
    }
    const handleDeleteAllNotifications = async () => {
      setLoaderBox(true);
      await deleteData({}, "notification", false, dispatch, navigate)
      .then((response) => {
          if (response.status === 200) {
            setNotifications(response.data);
          } else if (response.status === 404) {
              setMessage({ type: 1, content: t(response.data), proceed: "Okay", code: 404 });   
          } else {
              setMessage({ type: 1, content: t(response.data), proceed: "Okay", code: 500 });
          }
          setLoaderBox(false);
      })
      .catch((error) => {
          setMessage({ type: 1, content: error.message + "Something went wrong!", proceed: "Okay", code: 500 });
          setLoaderBox(false);
      });
    }

  return (
    <Container>
        <NotificationIcon
          onClick={() => setShowNotifications((prev) => !prev)}
          onMouseEnter={() => setShowNotifications(true)}
          onMouseLeave={() => setShowNotifications(false)}
          style={{ position: "relative" }}
        >
        <GetIcon icon="notification" fontSize={30} />
        {notifications?.data?.length > 0 &&
            notifications?.data?.filter((val) => !val.isRead).length > 0 && (
                <NotificationNumber>
                    {notifications?.data?.filter((val) => !val.isRead).length}
                </NotificationNumber>
            )}
        </NotificationIcon>

        <NotificationsContainer className={`${showNotifications?'show':'hide'}`} 
          onMouseEnter={() => {
            setShowNotifications(true);
            handleNotificationRead();
          }} onMouseLeave={() => setShowNotifications(false)}>
            <div style={{fontSize:'20px', fontWeight: 600}}>{t("notifications")}</div>
            {notifications?.data?.length> 0 ? (notifications?.data?.map((notification) => (
                <NotiListItem>
                    <Profile>{generateThumbnail(notification?.addedBy?.fullName, null, notification?.addedBy?.photo)}</Profile>
                    <div>
                        <div onClick={()=> navigate(notification.link)} style={{cursor:'pointer'}}>{t(notification?.title)}</div>
                        <div onClick={()=> navigate(notification.link)} style={{fontSize:'14px', cursor:'pointer'}}>{t(notification.content,{name: notification?.addedBy?.fullName})}</div>
                        <div onClick={()=> navigate(notification.link)} style={{fontSize:'14px', cursor:'pointer'}}>{getTimeAgo(notification?.createdAt, t)}</div>
                    </div>
                    <button onClick={(e)=> hanldeDeleteNotification(e,notification)}>
                      <GetIcon icon="close" fontSize={20} />
                    </button>
                </NotiListItem>
            ))) : <div style={{display:'flex',alignItems:'center',justifyContent:'center',width:'100%', height:'calc(100% - 50px)'}}><div>{t("noNotifications")}</div></div>}
            {notifications?.data?.length> 0 && <button onClick={(e)=> handleDeleteAllNotifications()} style={{width:'30px',height:'30px', position:'absolute', bottom: '10px', right:'10px', border:'none', backgroundColor:'transparent', cursor:'pointer'}}>
                <GetIcon icon="delete" fontSize={20} />
            </button>}
        </NotificationsContainer>
    </Container>
  )
}

export default Notification